export default "__VITE_ASSET__d1097a33__"